// extracted by mini-css-extract-plugin
export default {"modal":"UWE0iIvfXSa4WCaGAUiX","header":"E2B2P2DrQKobiYW3Ci0k","title":"Iv0zvYU4n4_XnvyCRQ4W","subTitle":"TiEUJkvP4hPUxAgG1ZlN"};